import {createSlice} from '@reduxjs/toolkit';
import AdminApi from "../../../api/AdminApi";
import {showNotification} from "./notification";
import { safeDecodeURIComponent } from '../../../components/admin/helper/formatters';

type State = {
    data: { [key: number]: { value: string, label: string } },
    isLoading: boolean,
    updatedAt: number | null,
    error: Object | null,
    cellId: number | null
}

const initialState = {
    data: {},
    isLoading: false,
    updatedAt: null,
    error: null,
	cellId: null
}

const referrerTypes = createSlice({
    name: 'referrerTypes',
    initialState,
    reducers: {
        fetchReferrerTypesStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
        },
        fetchReferrerTypesSuccess: (state: State, action) => {
			const cellId = action.payload.cellId;
            // @ts-ignore
            if (action.payload && (state.updatedAt === null || state.updatedAt < action.payload.requestInitTime) && action.payload.data) {
                const newData = action.payload.data.map((referrer: { id: string, name: string }) => {
                    let label = referrer.name.replaceAll(/_|-/g, ' ');

                    if (label.indexOf('.') === -1) {
                        label = label.charAt(0).toUpperCase() + label.slice(1);
                    }
                    return {
                        value: referrer.id,
                        label: safeDecodeURIComponent(label)
                    };
                });
            	state.data = {
					...state.data,
					[cellId]: newData
				}

                state.updatedAt = action.payload.requestInitTime;
            }
            state.isLoading = false;
            state.error = false;
            state.cellId = cellId;
        },
        fetchReferrerTypesFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload
        },
        resetReferrerTypes: (state: State, action) => {
            if (action.payload.cellId) {
                delete state.data[action.payload.cellId];
            }
        }
    }
});

// Actions
export const {
    fetchReferrerTypesStart,
    fetchReferrerTypesSuccess,
    fetchReferrerTypesFailed,
    resetReferrerTypes
} = referrerTypes.actions;

export default referrerTypes.reducer;

// Thunk
export const fetchReferrerTypes = (brands: string, cellId: number) => async (dispatch: Function) => {
    try {
        dispatch(fetchReferrerTypesStart());
        const api = new AdminApi();
        const requestInitTime = new Date().getTime();
        const result = await api.getReferrerTypes(brands);
        const payload = {
        	data: result,
			cellId,
            requestInitTime
		}
        dispatch(fetchReferrerTypesSuccess(payload));
    } catch (err: any) {
        dispatch(fetchReferrerTypesFailed(err));
		dispatch(showNotification('error', err.message));
	}
}
